import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { ViolationsScreen } from '@/features/hr-violations/violations-screen'
import { hasGrant } from '@/lib/me'

export const violationSearchSchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  severity: z.string().optional(),
  status: z.string().optional(),
  employee: z.string().optional(),
  department: z.string().optional(),
  violation_type_id: z.string().optional(),
  action: z.string().optional(),
  create: z.preprocess((value) => (value === 1 ? '1' : value), z.literal('1')).optional(),
})

export const Route = createFileRoute('/_authenticated/hr/violations/')({
  validateSearch: violationSearchSchema,
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'violation.view')) throw redirect({ to: '/hr' })
  },
  component: ViolationsScreen,
})
